// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"296":"component---src-pages-404-tsx","348":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"296":"bde7c3ae9ddda95009fc","348":"36f872c26542c9253e1b","492":"740fb23465c5f1ac9301","972":"131cdf4226de58aa7534"}[chunkId] + ".js";
};